import { useMemo } from 'react';
import { useCustomers } from '@/api/Customers';
import { useTemplateList } from '@/api/QuestionnaireTemplates';

export const useResponseLabels = () => {
  const { data: customers = [], isFetching: customersLoading } = useCustomers();
  const customerIds = useMemo(
    () => customers.map((c) => c.customerId),
    [customers],
  );
  const { data: templates = [], isFetching: templatesLoading } =
    useTemplateList(customerIds, 'perScope');

  const templateTitleByKey = useMemo(
    () =>
      templates.reduce<Record<string, string>>((acc, template) => {
        if (!(template.templateKey in acc)) {
          acc[template.templateKey] = template.title || template.templateKey;
        }
        return acc;
      }, {}),
    [templates],
  );

  const customerNameById = useMemo(
    () =>
      customers.reduce<Record<number, string>>((acc, customer) => {
        acc[customer.customerId] = customer.customerName;
        return acc;
      }, {}),
    [customers],
  );

  return {
    customers,
    templates,
    templateTitleByKey,
    customerNameById,
    isLoading: customersLoading || templatesLoading,
  };
};
